import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import loadable from '@loadable/component';
import React from 'react';
import sw from '@uswitch/ev-utils/switch';
import { getVariantPath } from '@uswitch/ev-utils/get-variant-path';
import withComponentBase from '../../helpers/with-component-base';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
export var categoryGuidesStylePath = function categoryGuidesStylePath(field, variant) {
  return getVariantPath({
    atomicType: 'modules',
    componentId: 'categoryGuide',
    variantName: variant,
    field: field
  });
};
var Default = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "default";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },
  importAsync: function importAsync() {
    return import(
    /* webpackChunkName: "default" */
    './default');
  },
  requireAsync: function requireAsync(props) {
    var _this = this;

    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./default");
    }

    return eval('require.resolve')("./default");
  }
});
var HtmlSitemap = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "html-sitemap";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },
  importAsync: function importAsync() {
    return import(
    /* webpackChunkName: "html-sitemap" */
    './html-sitemap');
  },
  requireAsync: function requireAsync(props) {
    var _this = this;

    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./html-sitemap");
    }

    return eval('require.resolve')("./html-sitemap");
  }
});

var CategoryGuides = function CategoryGuides(props) {
  return sw({
    'html-sitemap': function htmlSitemap() {
      return _jsx(HtmlSitemap, _objectSpread({}, props));
    },
    default: function _default() {
      return _jsx(Default, _objectSpread({}, props));
    }
  })(props.variant, props);
};

export default withComponentBase(CategoryGuides, {
  withHeaderFooter: true,
  headerStyles: {
    h3: {
      color: 'dark-2'
    }
  }
});
//# sourceMappingURL=index.js.map